// extracted by mini-css-extract-plugin
module.exports = {"button":"go-top-button-module--button--r1XTH","invisible":"go-top-button-module--invisible--2UR_d"};